<script>
export default {
  methods: {
    validateZip() {
      this.$nextTick(() => {
        if (!this.$refs.zip?.validate) {
          this.$set(
            this.errors,
            'zip',
            'Please enter a valid zip code.',
          );
        } else {
          this.$delete(this.errors, 'zip');
        }
      });
    },
  },
};
</script>
